// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * fps-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: local
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BanksResponseAPIModel,
    BanksResponseAPIModelFromJSON,
    BanksResponseAPIModelToJSON,
} from '../models';

export interface DictionaryControllerBanksRequest {
    ignoreSteps: boolean;
}

/**
 * DictionaryApi - interface
 * 
 * @export
 * @interface DictionaryApiInterface
 */
export interface DictionaryApiInterface {
    /**
     * 
     * @param {boolean} ignoreSteps 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DictionaryApiInterface
     */
    dictionaryControllerBanksRaw(requestParameters: DictionaryControllerBanksRequest): Promise<runtime.ApiResponse<BanksResponseAPIModel>>;

    /**
     */
    dictionaryControllerBanks(ignoreSteps: boolean): Promise<BanksResponseAPIModel>;

}

/**
 * 
 */
export class DictionaryApi extends runtime.BaseAPI implements DictionaryApiInterface {

    /**
     */
    async dictionaryControllerBanksRaw(requestParameters: DictionaryControllerBanksRequest): Promise<runtime.ApiResponse<BanksResponseAPIModel>> {
        if (requestParameters.ignoreSteps === null || requestParameters.ignoreSteps === undefined) {
            throw new runtime.RequiredError('ignoreSteps','Required parameter requestParameters.ignoreSteps was null or undefined when calling dictionaryControllerBanks.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/dictionary/banks`.replace(`{${"ignoreSteps"}}`, encodeURIComponent(String(requestParameters.ignoreSteps))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => BanksResponseAPIModelFromJSON(jsonValue));
    }

    /**
     */
    async dictionaryControllerBanks(ignoreSteps: boolean): Promise<BanksResponseAPIModel> {
        const response = await this.dictionaryControllerBanksRaw({ ignoreSteps: ignoreSteps });
        return await response.value();
    }

}
